import companyLogo from '../../../assets/images/company-logo.svg';
import { SignInForm } from '../../../components/forms/Forms';
import { Link } from 'react-router-dom';

const SignIn = () => {
  return (
    <main className='auth-page'>
      <Link to='/' className='logo'>
        <img src={companyLogo} alt='Sharpinvestr' />
      </Link>
      <SignInForm />
    </main>
  );
};

export default SignIn;
